export default "__VITE_ASSET__DXlcQX27__ 608w";